import { createReducerTypeSafe } from '@/utils/redux';

import {
  SaveConfirmationStateActionPayload,
  SaveProfileStatusActionPayload,
  SaveStateActionPayload,
  storeConfirmationState,
  storeFormPhone,
  storeIdentificationState,
  storeInitialization,
  StoreInitializationActionPayload,
  storeLogout,
  StorePhoneActionPayload,
  storeProfileIdentificationStatus,
  storeSavedPhone,
} from './actions';
import { initialState, State } from './types';

export const reducers = createReducerTypeSafe<State>(initialState, [
  [
    storeFormPhone,
    (state: State, { phone }: StorePhoneActionPayload): State => ({
      ...state,
      phone: {
        value: phone,
        hasError: phone.length !== 0 && phone.length < 10,
        modified: state.savedPhone !== phone,
      },
    }),
  ],
  [
    storeSavedPhone,
    (state: State, { phone }: StorePhoneActionPayload): State => ({
      ...state,
      savedPhone: phone,
      ...(state.phone
        ? {
          phone: {
            ...state.phone,
            modified: false,
          },
        }
        : {}),
    }),
  ],
  [
    storeIdentificationState,
    (state: State, { state: newState }: SaveStateActionPayload): State => ({
      ...state,
      state: newState,
    }),
  ],
  [
    storeInitialization,
    (
      state: State,
      { identificationState, confirmation, phone, profileIdentificationStatus }: StoreInitializationActionPayload,
    ): State => ({
      ...state,
      initialized: true,
      state: identificationState,
      profileIdentificationStatus,
      savedPhone: phone?.value,
      phone: { ...phone, hasError: false, modified: false },
      confirmation,
    }),
  ],
  [
    storeConfirmationState,
    (state: State, confirmation: SaveConfirmationStateActionPayload): State => ({ ...state, confirmation }),
  ],
  [
    storeProfileIdentificationStatus,
    (state: State, profileIdentificationStatus: SaveProfileStatusActionPayload): State => ({
      ...state,
      profileIdentificationStatus,
    }),
  ],
  [storeLogout, (): State => ({ initialized: true })],
]);

export default reducers;
